// Product Description Read More/Less Toggle
document.addEventListener('DOMContentLoaded', function() {
  const productDescriptions = document.querySelectorAll('.product-details .text-block[class*="__product_description_"], .product-details rte-formatter');
  
  productDescriptions.forEach(function(description) {
    // Store original content
    const originalContent = description.innerHTML;
    
    // Create a temporary element to measure line height
    const tempDiv = document.createElement('div');
    tempDiv.style.cssText = 'visibility: hidden; position: absolute; height: auto; white-space: nowrap;';
    tempDiv.innerHTML = 'Test';
    description.appendChild(tempDiv);
    const lineHeight = parseInt(window.getComputedStyle(tempDiv).lineHeight);
    description.removeChild(tempDiv);
    
    const collapsedHeight = lineHeight * 3; // ~3 lines
    
    // Only add toggle if content is longer than collapsed height
    if (description.scrollHeight > collapsedHeight + 20) {
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'position: relative;';
      
      // Move description into wrapper
      description.parentNode.insertBefore(wrapper, description);
      wrapper.appendChild(description);
      
      // Create toggle button
      const toggleButton = document.createElement('button');
      toggleButton.className = 'product-description-toggle';
      toggleButton.innerHTML = 'Skaityti daugiau';
      toggleButton.setAttribute('type', 'button');
      toggleButton.setAttribute('data-expanded', 'false');
      toggleButton.setAttribute('aria-expanded', 'false');
      
      // Insert button after wrapper
      wrapper.parentNode.insertBefore(toggleButton, wrapper.nextSibling);
      
      // Start collapsed
      description.style.maxHeight = collapsedHeight + 'px';
      
      // Toggle functionality
      toggleButton.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = this.getAttribute('data-expanded') === 'true';
        
        if (isExpanded) {
          // First, set max-height to current scroll height for smooth animation
          description.style.maxHeight = description.scrollHeight + 'px';
          
          // Force a reflow
          void description.offsetHeight;
          
          // Then collapse with smooth transition
          requestAnimationFrame(() => {
            description.style.maxHeight = collapsedHeight + 'px';
            description.classList.remove('is-expanded');
          });
          
          this.innerHTML = 'Skaityti daugiau';
          this.setAttribute('data-expanded', 'false');
          this.setAttribute('aria-expanded', 'false');
          
          // Smooth scroll to description top after transition
          setTimeout(() => {
            description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 400);
        } else {
          // First, expand the max-height
          description.style.maxHeight = description.scrollHeight + 'px';
          
          // Add expanded class to remove line-clamp
          description.classList.add('is-expanded');
          this.innerHTML = ' Skaityti mažiau';
          this.setAttribute('data-expanded', 'true');
          this.setAttribute('aria-expanded', 'true');
          
          // Reset max-height after transition
          setTimeout(() => {
            description.style.maxHeight = 'none';
          }, 400);
        }
      });
    }
  });
});

